import { em } from 'polished';

export default {
  root: {
    width: em(50),
    height: em(57),
  },
};
